import React from 'react';
import { Link } from 'react-router-dom';

import { generateId, formatDate } from '../../utilities/generic/Common.js'
import { safeStringComparison } from '../../utilities/generic/Forms.js'

import { directionHandler, directionPluralHandler, directionCheckHandler, safeSubstringFuzzyComparison, safeSubstringActiveComparison, splitAlternativeNameSubstringComparison, sanitizeString } from '../../utilities/generic/Forms.js'

export function backgroundMatchPerson(_this) {
  // If the user has already selected a real person during autocomplete, use that directly.
  if (_this.state.autocompletePerson && typeof _this.state.autocompletePerson !== "string") {
    return _this.state.autocompletePerson
  }

  // Favour certain values depending on direction based on data needed for upcoming pages
  const criteria = _this.state.direction === "arriving" ? "covid_pass_expiry_date" : "feedback_answer_times"

  let person = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    custom_attributes: [],
    covid_pass_expiry_date: null,
    feedback_answer_times: null
  };

  const profile = _this.props.location.state.profile

  let people = JSON.parse(localStorage.getItem("people")) || []
  const peopleMatchingProfileType = people.filter(person => person.type_of_person === profile.type_of_person)

  people = peopleMatchingProfileType.filter(person => {
    // Filter out anyone who has a non-comparative attribute. I.e. first_name John !== James.
    // Skip comparison if field isn't used. State value is "" by default, which fails the `safeStringComparison`.
    const first_name = profile.first_name_used ? safeStringComparison(sanitizeString(person.first_name), sanitizeString(_this.state.first_name)) : true
    const last_name = profile.last_name_used ? safeStringComparison(sanitizeString(person.last_name), sanitizeString(_this.state.last_name)) : true
    const email = profile.email_used ? safeStringComparison(person.email, _this.state.email) : true
    const phone = profile.phone_used ? safeStringComparison(sanitizeString(person.phone), sanitizeString(_this.state.phone)) : true

    return first_name && last_name && email && phone
  })

  // From the remaining list, count how many attributes match
  people.forEach(potentialPerson => {
    potentialPerson.matchingAttributes = countMatchingAttributes(potentialPerson, _this)
  });

  let sortedPeople = [people[0]]

  // Collect the people with the highest `matchingAttributes` number, and discard the rest
  for (const potentialPerson of people) {
    if (potentialPerson.matchingAttributes > sortedPeople[0].matchingAttributes) {
      sortedPeople = [potentialPerson]
    }
    else if (potentialPerson.matchingAttributes === sortedPeople[0].matchingAttributes) {
      sortedPeople.push(potentialPerson)
    }
  }

  // Prefer people with matching attributs needed for future pages, if any
  for (const potentialPerson of sortedPeople) {
    if (potentialPerson === undefined || potentialPerson.matchingAttributes === 0) {
      // No matches means no bueno.
      break
    }

    person = potentialPerson

    if (criteria === "covid_pass_expiry_date" && (new Date(potentialPerson.covid_pass_expiry_date) < new Date().setHours(0,0,0,0) || potentialPerson.covid_pass_exemption === true)) {
      // stop looking for matches if a match does not require a covid QR scan
      break
    }

    if (criteria === "feedback_answer_times" && (potentialPerson.feedback_answer_times !== null)) {
      // stop looking for matches if a match has feedback answer times
      break
    }
  }

  // Fill in any missing details if provided in the form
  person.first_name = person.first_name === "" ? _this.state.first_name : person.first_name
  person.last_name = person.last_name === "" ? _this.state.last_name : person.last_name
  person.email = person.email === "" ? _this.state.email : person.email
  person.phone = person.phone === "" ? _this.state.phone : person.phone

  return person
}

export function countMatchingAttributes(person, _this) {
  let totalMatches = 0
  const fields = ["first_name", "last_name", "email", "phone"]

  fields.forEach((field) => {
    if (person[field] === null || _this.state[field] === null) {
      return
    }

    if (person[field].trim() === "" && _this.state[field].trim() === "") {
      return
    }
    
    let personField = person[field].trim().toLowerCase()
    let stateField = _this.state[field].trim().toLowerCase()

    if (field !== "email") {
      personField = sanitizeString(personField)
      stateField = sanitizeString(stateField)
    }

    if (personField === stateField) {
      totalMatches += 1
    }
  })

  return totalMatches
}

export function collectPeopleByIds(person, checkedInPeopleIds) {
  if (checkedInPeopleIds.includes(person.id)) {
    return person
  }
}

export function collectPeopleByValue(person, key, value) {
  var personValue = person[key]
  if (personValue === value) {
    return person
  }
}

export function collectValues(person, key, length) {
  if (person[key] !== null) {
    var partialPersonValue = person[key].substr(0, length)
    return partialPersonValue
  }
}

export function collectPeopleByType(_this) {
  let collectPeopleByType;

  let typeOfPerson = _this.props.location.state.profile.type_of_person

  let people = JSON.parse(localStorage.people);

  if (_this.state.direction === "leaving") {
    let checkedInPeopleIds = JSON.parse(localStorage.checked_in_people);

    // first, collect people that are logged in
    let collectionOfCheckedInPeople = people.filter(person => collectPeopleByIds(person, checkedInPeopleIds))

    // then collect people based on type of person
    collectPeopleByType = collectionOfCheckedInPeople.filter(person => collectPeopleByValue(person, "type_of_person", typeOfPerson));
  }
  else {
    // or otherwise first, collect people based on type of person
    collectPeopleByType = people.filter(person => collectPeopleByValue(person, "type_of_person", typeOfPerson));
  }

  if (_this.state.autocompleteDisabled) {
    collectPeopleByType = collectPeopleByType.filter(person => collectPeopleByValue(person, "autocomplete", true));
  }
  
  return collectPeopleByType;
}

export function checkMatchingCharacters(value, personValue) {
  if (value.toLowerCase() === personValue.toLowerCase()) {
    return true;
  }
}

export function eligiblePlannedEvent(planned_event, currentTime) {
  const start_time = new Date(planned_event.start_time)
  const end_time = new Date(planned_event.end_time)

  // allow events that will be ongoing up to 8 hours before or 8 hours from now
  return (new Date(start_time.setHours(start_time.getHours() - 8)) < currentTime && new Date(end_time.setHours(end_time.getHours() + 8) > currentTime))
}

export function findPerson(people, partialValue, key, length) {
  for (var i = 0; i < people.length; i++) {
    let person = people[i]

    if (person[key] !== null && person[key].substr(0, length) === partialValue) {
      return person;
    }
  }
}

export function findPlannedEvents(person) {
  const planned_events = JSON.parse(localStorage.getItem("planned_events")) || []

  let arriving_planned_events = planned_events.filter(planned_event => planned_event.arriving_person_ids.includes(person.id))
  let hosting_planned_events = planned_events.filter(planned_event => planned_event.host_person_ids.includes(person.id))

  const currentTime = new Date()

  if (arriving_planned_events.length > 0) {
    arriving_planned_events = arriving_planned_events.filter(arriving_planned_event => eligiblePlannedEvent(arriving_planned_event, currentTime))
  }

  if (hosting_planned_events.length > 0) {
    hosting_planned_events = hosting_planned_events.filter(hosting_planned_event => eligiblePlannedEvent(hosting_planned_event, currentTime))
  }

  if (arriving_planned_events.length + hosting_planned_events.length > 0) {
    let people = JSON.parse(localStorage.getItem("people"))

    hosting_planned_events.forEach((hosting_planned_event) => {
      let first_arriving = people.find(person => person.id === hosting_planned_event.arriving_person_ids[0])

      hosting_planned_event.first_arriving = first_arriving && first_arriving.full_name
    })
    arriving_planned_events.forEach((arriving_planned_event) => {
      let first_host = people.find(person => person.id === arriving_planned_event.host_person_ids[0])

      arriving_planned_event.first_host = first_host && first_host.full_name
    })
  }


  return [arriving_planned_events, hosting_planned_events]
}

export function selectPersonThroughAutocompletion(name, value, _this) {
  let sanitizedValue = value.trim()
  
  if (name !== "email") {
    sanitizedValue = sanitizeString(sanitizedValue)
  }
  
  if (sanitizedValue.length < 3) {
    return;
  }

  const collectionOfPeopleByType = collectPeopleByType(_this);

  // count how many matches we got (excluding the previously rejected autocompletePerson) and,
  // if there's only one match, return that person
  let potentialMatches = [];
  collectionOfPeopleByType.forEach((person) => {
    if (name === "first_name") {
      // Check `first_name` and `alternate_name`
      if (safeSubstringFuzzyComparison(sanitizeString(person["first_name"]), sanitizedValue) && JSON.stringify(person) !== JSON.stringify(_this.state.rejectedAutocompletePerson)) {
        potentialMatches.push(person);
        return
      }

      if (splitAlternativeNameSubstringComparison(person["alternate_name"], value) && JSON.stringify(person) !== JSON.stringify(_this.state.rejectedAutocompletePerson)) {
        potentialMatches.push(person);
        return
      }
    }
    else {
      // Only check `[name]` (`last_name`, `phone`, or `email`)
      let otherAttribute = person[name]
      if (name !== "email") {
        otherAttribute = sanitizeString(otherAttribute)
      }

      if (safeSubstringFuzzyComparison(otherAttribute, sanitizedValue) && JSON.stringify(person) !== JSON.stringify(_this.state.rejectedAutocompletePerson)) {
        potentialMatches.push(person);
      }
    }
  });

  // if there's more than one match, use other fields to narrow down further, only excluding active mismatches
  potentialMatches = potentialMatches.filter((potentialMatch) => (
    (
      safeSubstringFuzzyComparison(sanitizeString(potentialMatch.first_name), sanitizeString(_this.state.first_name)) ||
      splitAlternativeNameSubstringComparison(potentialMatch.alternate_name, _this.state.first_name)
    ) &&
    safeSubstringFuzzyComparison(sanitizeString(potentialMatch.last_name), sanitizeString(_this.state.last_name)) &&
    safeSubstringFuzzyComparison(potentialMatch.email, _this.state.email) &&
    safeSubstringFuzzyComparison(sanitizeString(potentialMatch.phone), sanitizeString(_this.state.phone))
  ))
  // filter out any potential matches that don't have at least 1 active match on a filled field
  potentialMatches = potentialMatches.filter((potentialMatch) => (
    (_this.state.first_name.trim().length > 0 && safeSubstringActiveComparison(sanitizeString(potentialMatch.first_name), sanitizeString(_this.state.first_name))) ||
    (_this.state.first_name.trim().length > 0 && splitAlternativeNameSubstringComparison(potentialMatch.alternate_name, _this.state.first_name)) ||
    (_this.state.last_name.trim().length > 0 && safeSubstringActiveComparison(sanitizeString(potentialMatch.last_name), sanitizeString(_this.state.last_name))) ||
    (_this.state.email.trim().length > 0 && safeSubstringActiveComparison(potentialMatch.email, _this.state.email)) ||
    (_this.state.phone.trim().length > 0 && safeSubstringActiveComparison(sanitizeString(potentialMatch.phone), sanitizeString(_this.state.phone)))
  ))

  // if there's still more that one match, filter again using only active matches for occupied fields
  if (potentialMatches.length > 1) {
    potentialMatches = potentialMatches.filter((potentialMatch) => ((
      (
        safeSubstringActiveComparison(sanitizeString(potentialMatch.first_name), sanitizeString(_this.state.first_name)) ||
        splitAlternativeNameSubstringComparison(potentialMatch.alternate_name, _this.state.first_name)
      ) &&
      safeSubstringActiveComparison(sanitizeString(potentialMatch.last_name), sanitizeString(_this.state.last_name)) &&
      safeSubstringActiveComparison(potentialMatch.email, _this.state.email) &&
      safeSubstringActiveComparison(sanitizeString(potentialMatch.phone), sanitizeString(_this.state.phone))
    )))
  }

  // return if it's been narrowed to one
  if (potentialMatches.length === 1) {
    let person = potentialMatches[0]

    return person
  }
}

export function handleAutocomplete(event) {
  let value = event.target.value;

  if (value === "yes") {
    const person = this.state.autocompletePerson
    const profile = this.props.location.state.profile

    // advance to next page if auto create is disabled
    if (profile.disable_auto_create === true) {
      // stop advance if required fields are missing
      const fieldsMissing = handleMissingFields(person, profile, this)
      if (fieldsMissing) {
        return
      }

      let arriving_planned_events = []
      let hosting_planned_events = []

      if (this.state.direction === "arriving") {
        [arriving_planned_events, hosting_planned_events] = findPlannedEvents(person)
      }

      if (arriving_planned_events.length === 0 && hosting_planned_events.length === 0) {
        savePersonDetails(this, directionHandler(this), directionPluralHandler(this), person);
      }
      else {
        this.setState({arriving_planned_events, hosting_planned_events})
      }

      return
    }

    const custom_attributes = {}

    person.custom_attributes && person.custom_attributes.forEach((person_custom_attribute) => {
      custom_attributes[person_custom_attribute.id] = person_custom_attribute.value
    })

    this.setState({
      first_name: person.first_name,
      last_name: person.last_name,
      email: person.email,
      phone: person.phone,
      custom_attributes: custom_attributes,
      autocompleteLock: true,
      obfuscatedFields: ["phone", "email"],
      autocompleteField: "" // Close the AutoComplete modal
    })
  }
  else if (value === "no") {
    this.rejectAutocompletePerson()
  }

  event.preventDefault();
}

function handleMissingFields(person, profile, _this) {
  let missingRequiredFields = [];
  ["first_name", "last_name", "phone", "email"].forEach(field => {
    if (!person[field] && profile[`${field}_required`]) {
      missingRequiredFields.push(field)
    }
  })

  const requiredCustomAttributes = profile.custom_attributes.filter(attribute => attribute.required === true)
  let missingRequiredCustomAttributes = [];

  if (requiredCustomAttributes.length > 0) {
    // Check if required Custom Attributes are missing
    const required_ids = requiredCustomAttributes.map(attribute => attribute.id);
    const completed_ids = person.custom_attributes.filter(attribute => attribute.value !== "").map(attribute => attribute.id);

    missingRequiredCustomAttributes = required_ids.filter(id => !completed_ids.includes(id))
  }

  // Exit early if required attributes are missing
  if (missingRequiredFields.length > 0 || missingRequiredCustomAttributes.length > 0) {
    let custom_attributes = {}

    person.custom_attributes && person.custom_attributes.forEach((person_custom_attribute) => {
      custom_attributes[person_custom_attribute.id] = person_custom_attribute.value
    })

    _this.setState({
      first_name: person.first_name,
      last_name: person.last_name,
      email: person.email,
      phone: person.phone,
      custom_attributes: custom_attributes,
      autocompleteLock: true,
      obfuscatedFields: ["phone", "email"],
      missingRequiredFields: missingRequiredFields,
      missingRequiredCustomAttributes: missingRequiredCustomAttributes,
      autocompleteField: "" // Close the AutoComplete modal
    })

    _this.validator.allValid()
    _this.validator.showMessages();
    _this.forceUpdate();

    return true
  }

  return false
}

export function rejectAutocompletePerson() {
  this.setState((prevState) => ({
    "autocompletePerson": "",
    "autocompleteField": "",
    "rejectedAutocompletePerson": prevState.autocompletePerson,
    "autocompleteLock": false
  }));
}

export function handlePersonChange(event) {
  let name = event.target.name;
  let value = event.target.value;

  this.setState({[name]: value});

  if (this.state.autocompleteLock) {
    return
  }

  this.setState({"autocompletePerson": ""});
  this.setState({"autocompleteField": ""});

  let person = selectPersonThroughAutocompletion(name, value, this)

  if (person) {
    this.setState({"autocompletePerson": person});
    this.setState({"autocompleteField": name});
  }
}

export function resetObfuscatedField(event) {
  let name = event.target.name;

  if (this.state.obfuscatedFields.includes(name)) {
    // Remove obfuscated protection, and reset value to empty string
    this.setState((prevState) => ({
      [name]: "",
      obfuscatedFields: prevState.obfuscatedFields.filter((field) => field !== name)
    }));

  }
}

export function handlePlannedEventSubmit(event) {
  let person = this.state.autocompletePerson || this.state.backgroundmatchPerson
  savePersonDetails(this, directionHandler(this), directionPluralHandler(this), person);

  event.preventDefault();
}

export function savePersonDetails(_this, direction, directions, person) {
  if (person.id === undefined && _this.props.location.state.profile.disable_auto_create === true) {
    // If AutoCreate is disabled and the person isn't checking in through AutoComplete, block them from proceeding.
    _this.setState({"autoCreateMessage": true})
  }
  else {
    let app_id = generateId();
    _this.setState({"app_id": app_id})

    let details;

    // "direction" is a proxy for either an "arrival" or "departure" variable, depending on where this function is called. The directionCheckHandler autopopulates with eithier check_in_time or check_out_time in keeping with "direction"
    details = {
      [directionCheckHandler(_this)]: formatDate(new Date()),
      person_id: person?.id,
      first_name: _this.state.autocompleteLock ? _this.state.first_name : person.first_name,
      last_name: _this.state.autocompleteLock ? _this.state.last_name : person.last_name,
      email: _this.state.autocompleteLock ? _this.state.email : person.email,
      phone: _this.state.autocompleteLock ? _this.state.phone : person.phone,
      type_of_person: _this.props.location.state.profile.type_of_person,
      profile_id: _this.props.location.state.profile.id,
      app_id: app_id,
      version: process.env.REACT_APP_COMMIT_HASH
    }

    if (direction === "arrival") {
      details.planned_event_ids = _this.state.planned_event_ids
      saveCustomAttributes(_this.state.custom_attributes, app_id) // Save Custom Attribute data if required ones were requested on the Arrival page
    }

    takePhotoIfRequired(_this, app_id);

    // directions is a pluralized form of "direction" to allow data to flow properly from "arrival" or "departure" into "arrivals" or "departures" respectively.
    directions = JSON.parse(localStorage.getItem(directions))

    // Create arrivals/departures array if it doesn't exist
    if (directions === null) {
      directions = []
    }

    // Append to arrivals/departures array, and save to semi-permanent storage
    directions.push(details)
    // directionPluralHandler is another way of grabbing "arrivals"/"departures" once "directions" stops returning a string and instead returns an array
    localStorage.setItem(directionPluralHandler(_this), JSON.stringify(directions))

    // Remove person from checked_in_groups on departure
    if (_this.state.direction === "leaving") {
      if (person.group_id) {
        const groups = JSON.parse(localStorage.getItem("checked_in_groups"))

        if (groups[person.group_id] !== undefined) {
          groups[person.group_id] = groups[person.group_id]?.filter(person_id => person_id !== person.id)

          localStorage.setItem("checked_in_groups", JSON.stringify(groups))
        }
      }
    }

    _this.setState({validDetails: true})
  }
}

export function fullNameAutoMatch(typed_name, people) {
  const potentialMatches = people.filter(person => {
    let listOfFullNames = [`${person.first_name} ${person.last_name}`]
    if (person.alternate_name && person.alternate_name.length > 0) {
      let alternateFullNames = person.alternate_name.split(", ").map(alternate_name => `${alternate_name} ${person.last_name}`)
      listOfFullNames = listOfFullNames.concat(alternateFullNames)
    }
    return listOfFullNames.filter(fullName => safeStringComparison(sanitizeString(typed_name), sanitizeString(fullName))).length > 0
  })

  if (potentialMatches.length === 1) {
    return potentialMatches[0].id
  }
}

export function saveCustomAttributes(custom_attributes, arriving_app_id) {
  if (custom_attributes === undefined || Object.keys(custom_attributes).length === 0) {
    return
  }

  let customAttributes = JSON.parse(localStorage.getItem("custom_attributes"))

  // Create custom_attributes array if it doesn't exist
  if (customAttributes === null) {
    customAttributes = []
  }

  // Loop through custom_attributes looking for a matching arriving_app_id
  const index = customAttributes.findIndex(attribute => attribute.arriving_app_id === arriving_app_id);

  if (index !== -1) {
    // Existing custom_attribute found. Appending new data.
    customAttributes[index].custom_attributes = {
      ...customAttributes[index].custom_attributes,
      ...custom_attributes
    };
  } else {
    // Existing custom_attribute not found. Creating new data.
    const customAttribute = {
      "custom_attributes": custom_attributes,
      "arriving_app_id": arriving_app_id,
      "app_id": generateId(),
      "version": process.env.REACT_APP_COMMIT_HASH,
      "created_at": formatDate(new Date())
    }

    customAttributes.push(customAttribute)
  }

  // Append to custom_attributes array, and save to semi-permanent storage
  localStorage.setItem("custom_attributes", JSON.stringify(customAttributes))
}

export function takePhotoIfRequired(_this, app_id) {
  if (_this.state.photoRequired) {
    if (_this.state.autocompletePerson.photo_opt_out) {
      return _this.setState({ photoRequired: false })
    }

    const video = document.getElementById('video-container');
    const canvas = document.getElementById('canvas-container');

    let width = 320;
    let height = (video.videoHeight / video.videoWidth) * width;

    video.setAttribute("width", width);
    video.setAttribute("height", height);
    canvas.setAttribute("width", width);
    canvas.setAttribute("height", height);

    const context = canvas.getContext("2d");
    canvas.width = width;
    canvas.height = height;
    context.drawImage(video, 0, 0, width, height);

    const data = canvas.toDataURL("image/png");
    if (data !== "data:,") {
      localStorage.setItem(`${_this.state.direction}photo${app_id}`, data.replace(/^data:image\/(png|jpg);base64,/, ""))
    }

    _this.setState({photoCaptured: true})
  }
}

export function cleanupVideoStream(stream) {
  if (stream === undefined) {
    return
  }

  stream.getTracks().forEach((track) => {
    track.stop();
  });
}

export function photoRequired() {
  if (this.props.location.state === undefined) {
    return false
  }

  // take no photos if the device's local storage is overloaded
  if (localStorage.getItem("too_many_photos")){
    return false
  }

  const photo_required = this.props.location.state.profile[`${this.state.direction}_photo_required`]

  // always take a photo for "always", take a photo 1/10 times for "sometimes"
  return photo_required === "always" || (photo_required === "sometimes" && Math.random() * 10 <= 1)
}

export function handlePersonSubmit(event) {
  if (this.validator.allValid()) {

    let arriving_planned_events = []
    let hosting_planned_events = []

    const matchedPerson = backgroundMatchPerson(this)
    this.setState({ backgroundmatchPerson: matchedPerson })

    if (this.state.direction === "arriving" && matchedPerson) {
      [arriving_planned_events, hosting_planned_events] = findPlannedEvents(matchedPerson)
    }

    if (arriving_planned_events.length === 0 && hosting_planned_events.length === 0) {
      savePersonDetails(this, directionHandler(this), directionPluralHandler(this), matchedPerson);
    }
    else {
      this.setState({
        arriving_planned_events: arriving_planned_events,
        hosting_planned_events: hosting_planned_events
      })
    }
  }
  else {
    this.validator.showMessages();
    this.forceUpdate();
  }

  event.preventDefault();
}

export function fieldDetails(name, _this) {
  let person = _this.state.autocompletePerson

  if (name === "first_name" || name === "last_name") {
    return (
      <div className="value">
        Are you <strong>{person.full_name}?</strong>
      </div>
    )
  }

  if (name === "email") {
    return (
      <div className="value">
        Is this your email address?
        <br />
        <strong>{person.email}</strong>
      </div>
    )
  }

  if (name === "phone") {
    return (
      <div className="value">
        Is this your phone number?
        <br />
        <strong>{person.phone}</strong>
      </div>
    )
  }
}

export function displayAutocompletePersonForSelecting(name, _this) {
  if (_this.state.autocompleteField === name && (_this.state.direction === "leaving" || (_this.state.hosting_planned_events.length === 0 && _this.state.arriving_planned_events.length === 0))) {
    return (
      <div className="autocomplete-container">
        <div className="autocomplete-content">
          {fieldDetails(name, _this)}
          <button className="autocomplete-button" value="yes" onClick={_this.handleAutocomplete}>Yes</button>
          <button className="autocomplete-button" value="no" onClick={_this.handleAutocomplete}>No</button>
        </div>
      </div>
    )
  }
}

export function displayAutocreateNotAllowedMessage(_this) {
  const typeOfPerson = _this.props.location.state.profile.type_of_person
  const titleCaseTypeOfPerson = typeOfPerson.charAt(0).toUpperCase() + typeOfPerson.slice(1);

  if (_this.state.autoCreateMessage === true) {
    return (
      <div className="popup-container">
        <div className="popup-content">
          <p>The details you entered do not match anyone on the system.</p>
          <p>Please return to the home screen and try again.</p>

          <div className="popup-padding">
            <Link to={{ pathname: '/'}} className="popup-button">
              Home
            </Link>
          </div>

          <div className="popup-small">The {titleCaseTypeOfPerson} profile does not allow AutoCreate.</div>
        </div>
      </div>
    )
  }
}
